export const userAgent = navigator.userAgent.toLowerCase();
export const android = /android/i.test(userAgent);
export const ios = /iphone|ipad|ipod/i.test(userAgent);
export const mobile = android || ios;
export const chipsAppCode = "448dc5fa-45cc-437e-b060-0608f76cae07";

export function getChipsUid() {
  try {
    // eslint-disable-next-line no-undef
    return JSON.parse(chipsApp.getUserInfo()).uid;
  } catch (e) {
    return "";
  }
}

function getChipsAppVersionValue() {
  const indexOf = userAgent.indexOf("chips");
  if (indexOf >= 0) {
    const chips = userAgent.substring(indexOf).split(" ")[0];
    return parseChipsAppVersionValue(chips.split("/")[1]);
  } else {
    return -1;
  }
}

function parseChipsAppVersionValue(versionName) {
  const versionRatio = [1000000, 1000, 1];
  var value = 0;
  versionName.split(".").forEach((version, index) => {
    value = value + Number(version * versionRatio[index]);
  });

  return value;
}

export function showBottomSheet(attributes) {
  // ios bug fix
  if (ios) {
    const currentVersion = getChipsAppVersionValue();
    if (
      currentVersion >= parseChipsAppVersionValue("1.30.10") &&
      currentVersion <= parseChipsAppVersionValue("1.30.11")
    ) {
      if (attributes.primary_button_text) {
        const temp = {
          primary_button_text: attributes.primary_button_text,
          primary_button_style: attributes.primary_button_style,
          secondary_button_text: attributes.secondary_button_text,
          secondary_button_style: attributes.secondary_button_style,
        };
        attributes.primary_button_text = temp.secondary_button_text;
        attributes.primary_button_style = temp.secondary_button_style;
        attributes.secondary_button_text = temp.primary_button_text;
        attributes.secondary_button_style = temp.primary_button_style;
      }
    }
  }

  try {
    // eslint-disable-next-line no-undef
    chipsApp.showBottomSheet(JSON.stringify(attributes));
  } catch (e) {}
}

export function moveToLogin() {
  window.location.href = `chips://login`;

  if (ios) {
    setPageConsumedCallback(() => {
      window.location.href = `chips://web?url=${encodeURIComponent(
        window.location.href,
      )}`;
      setPageConsumedClose();
    });
  } else {
    setPageConsumedCallback(() => {
      window.location.reload();
    });
  }
}

let pageConsumedEventListener;

export function setPageConsumedClose() {
  setPageConsumedCallback(() => {
    if (!document.hidden) {
      // eslint-disable-next-line no-undef
      chipsApp.close();
    }
  });
}

export function setPageConsumedCallback(callback) {
  removePageConsumedEventListener();
  pageConsumedEventListener = () => {
    if (!document.hidden) {
      removePageConsumedEventListener();
      callback();
    }
  };
  document.addEventListener("visibilitychange", pageConsumedEventListener);
}

export function removePageConsumedEventListener() {
  if (pageConsumedEventListener) {
    document.removeEventListener("visibilitychange", pageConsumedEventListener);
    pageConsumedEventListener = null;
  }
}

export function trackEvent(name, data) {
  try {
    // eslint-disable-next-line no-undef
    chipsApp.trackEvent(name, data ? JSON.stringify(data) : "{}");
  } catch (e) {}
}

export function openWebView(landingUrl, hasHeader, title) {
  try {
    // eslint-disable-next-line no-undef
    if (chipsApp) {
      const params = {
        has_header: !!hasHeader,
        title: title ? title : " ",
        url: landingUrl,
      };

      const query = Object.keys(params)
        .flatMap((key) => `${key}=${encodeURIComponent(params[key])}`)
        .join("&");
      window.location.href = `chips://web?${query}`;
    }
  } catch (e) {
    window.location.href = landingUrl;
  }
}

export function getInsetTop() {
  try {
    // eslint-disable-next-line no-undef
    const statusBarHeight = chipsApp.getStatusBarHeight();
    if (statusBarHeight) {
      return statusBarHeight + "px";
    }
  } catch (e) {}

  return getComputedStyle(document.documentElement).getPropertyValue(
    "--safe-area-inset-top",
  );
}

export function getInsetBottom() {
  return getComputedStyle(document.documentElement).getPropertyValue(
    "--safe-area-inset-bottom",
  );
}

export function calc(size, offset) {
  // size * max-width / pivot-size + offset
  return `calc(${size} * min(100vw, 768px) / 360 + ${
    offset ? offset : 0 + "px"
  })`;
}
